/* Hook encargado de crear y modificar la Sucursal

Autor: Carolina Rojas
Fecha: 06-02-2025
*/
import { useState } from 'react'

import { customPost } from '../utils/customFetch.ts'
import Branch from '../interfaces/Branch.ts'

import { makeUrlBranchEdit } from './connectionData.tsx'

const useBranchPoster = () => {
  const [errorPostBranch, setErrorPostBranch] = useState<string | null>(null)
  const [loadingPost, setLoadingPost] = useState<boolean>(false)

  const postBranch = async (branch: Branch, id: string) => {
    setLoadingPost(true)

    try {
      const apiUrl = makeUrlBranchEdit(id)

      const res = await customPost<{ _id: string }>(apiUrl, branch)
      setErrorPostBranch(null)

      if (!res || !res._id) {
        throw new Error('No se pudo obtener el ID de la sucursal.')
      }

      return res._id
    } catch (err) {
      // Assert the error as an instance of Error
      if (err instanceof Error) {
        setErrorPostBranch(err.message)
      } else {
        setErrorPostBranch('An unknown error occurred')
      }

      return null
    } finally {
      setLoadingPost(false)
    }
  }

  // Exponemos estas variables al exterior
  return { errorPostBranch, loadingPost, postBranch }
}
export default useBranchPoster
